import React from "react";

const TrackSvg = () => {
  return (
    <>
      <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g style={{mixBlendMode: "luminosity"}} clipPath="url(#clip0_1648_21336)">
          <circle cx="60.7768" cy="62.7768" r="60.7768" fill="#F5F8FF" />
          <circle cx="60.7767" cy="62.7767" r="47.2709" fill="#E4ECFE" />
          <path
            d="M89.029 103.448H32.6552C31.1888 103.448 30 102.26 30 100.793V24.6552C30 23.1888 31.1888 22 32.6552 22H76.6726L91.6842 35.8569V100.793C91.6842 102.26 90.4955 103.448 89.029 103.448Z"
            fill="#F5F8FF"
            stroke="#B7CEFF"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.7852 39.0229C36.7852 38.0136 37.6034 37.1953 38.6127 37.1953H73.9995C75.0089 37.1953 75.8271 38.0136 75.8271 39.0229C75.8271 40.0322 75.0089 40.8505 73.9995 40.8505H38.6127C37.6034 40.8505 36.7852 40.0322 36.7852 39.0229Z"
            fill="#2D56B2"
          />
          <path
            d="M77.0645 21L92.6851 35.4191H81.0645C78.8553 35.4191 77.0645 33.6282 77.0645 31.4191V21Z"
            fill="#B7CEFF"
          />
          <rect
            width="14.7292"
            height="2.53951"
            rx="1.26976"
            transform="matrix(-0.707107 0.707107 0.707107 0.707107 20.416 23)"
            fill="#2D56B2"
          />
          <rect
            width="14.7292"
            height="2.53951"
            rx="1.26976"
            transform="matrix(0.707107 0.707107 0.707107 -0.707107 10 24.7949)"
            fill="#2D56B2"
          />
          <circle
            cx="26.3412"
            cy="58.3412"
            r="4.3412"
            stroke="#5388FE"
            strokeWidth="4"
          />
          <circle
            cx="116.608"
            cy="71.6078"
            r="3.60776"
            stroke="#2D56B2"
            strokeWidth="4"
          />
          <circle
            cx="10.1101"
            cy="79.1101"
            r="1.11008"
            stroke="#4F86FF"
            strokeWidth="3"
          />
          <path
            d="M62.9154 125.958C84.7875 125.958 102.518 124.923 102.518 123.646C102.518 122.369 84.7875 121.334 62.9154 121.334C41.0433 121.334 23.3125 122.369 23.3125 123.646C23.3125 124.923 41.0433 125.958 62.9154 125.958Z"
            fill="#B7CEFF"
          />
          <path
            d="M83.7391 89.7785L89.6896 83.8279L114.21 104.757C117.214 107.32 117.394 111.899 114.602 114.691V114.691C111.81 117.483 107.231 117.302 104.668 114.299L83.7391 89.7785Z"
            fill="#1A3166"
          />
          <path
            d="M87.9648 94.7296L104.669 114.3C107.232 117.304 111.811 117.484 114.603 114.692C117.395 111.901 117.215 107.321 114.211 104.758L92.3644 86.1113C91.4853 89.2808 89.9722 92.1987 87.9648 94.7296Z"
            fill="#2D56B2"
          />
          <path
            d="M76.945 54.0716L61.5644 89.7798C61.3275 89.5966 61.0928 89.4068 60.8624 89.2149C59.3758 87.9577 58.0812 86.4807 57.0215 84.8326L70.3066 53.9887C72.5076 53.6263 74.7533 53.6544 76.945 54.0716Z"
            fill="white"
          />
          <path
            d="M87.8781 60.2666L73.4172 93.8393C70.4135 93.8426 67.4493 93.1395 64.7539 91.7845L80.5442 55.123C83.3416 56.2414 85.8506 58.0011 87.8781 60.2666Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.6275 59.0078C61.8273 60.8304 59.6092 63.4672 58.263 66.5923C56.9166 69.7179 56.5059 73.1854 57.0859 76.5537C57.6658 79.9219 59.2086 83.0306 61.5098 85.4895C63.8104 87.9478 66.7649 89.6459 69.9956 90.3792C73.2259 91.1124 76.5965 90.8504 79.684 89.6242L79.6843 89.6241C81.7353 88.8098 83.6133 87.5889 85.2095 86.028C86.8059 84.4669 88.0891 82.5963 88.9829 80.5214C89.8768 78.4463 90.3628 76.2093 90.4118 73.9387C90.4607 71.668 90.0715 69.4109 89.2676 67.2969L89.2675 67.2966C88.0571 64.1127 85.9542 61.377 83.234 59.4289C80.5147 57.4813 77.2984 56.4062 73.9919 56.3316C70.6855 56.257 67.4269 57.1858 64.6275 59.0078ZM53.0885 64.3633C54.8683 60.2314 57.8111 56.7218 61.554 54.2857C65.2977 51.8491 69.6706 50.5984 74.1191 50.6988C78.5675 50.7992 82.8811 52.246 86.5146 54.8482C90.1473 57.4499 92.9348 61.0876 94.534 65.2946C95.5963 68.0883 96.1092 71.0666 96.0447 74.0601C95.9802 77.0536 95.3394 80.0065 94.1574 82.7504C92.9754 85.4944 91.2744 87.9775 89.1487 90.0563C87.0229 92.135 84.514 93.7686 81.7636 94.8606C77.6208 96.5059 73.0906 96.8592 68.7485 95.8737C64.4069 94.8882 60.4576 92.6108 57.3961 89.3394C54.3351 86.0687 52.2981 81.951 51.5334 77.5098C50.7687 73.0688 51.3088 68.4946 53.0885 64.3633Z"
            fill="#2D56B2"
          />
          <path
            d="M112.011 104.953L94.3447 90.4862C93.7971 90.0378 93.1591 90.6684 93.6025 91.2199L107.868 108.963C108.419 109.648 109.214 110.093 110.041 110.179L110.531 110.23C112.223 110.407 113.496 109.07 113.246 107.379L113.188 106.985C113.074 106.209 112.648 105.474 112.011 104.953Z"
            fill="#9FBDFF"
          />
          <rect
            width="22.9185"
            height="3.95147"
            rx="1.97574"
            transform="matrix(-0.707107 0.707107 0.707107 0.707107 80.2051 64)"
            fill="#2D56B2"
          />
          <rect
            width="22.9185"
            height="3.95147"
            rx="1.97574"
            transform="matrix(0.707107 0.707107 0.707107 -0.707107 64 66.7949)"
            fill="#2D56B2"
          />
          <rect
            width="12.8004"
            height="2.20696"
            rx="1.10348"
            transform="matrix(-0.707107 0.707107 0.707107 0.707107 111.051 39)"
            fill="#5388FE"
          />
          <rect
            width="12.8004"
            height="2.20696"
            rx="1.10348"
            transform="matrix(0.707107 0.707107 0.707107 -0.707107 102 40.5605)"
            fill="#5388FE"
          />
          <rect
            width="10.8561"
            height="1.87174"
            rx="0.935869"
            transform="matrix(-0.707107 0.707107 0.707107 0.707107 44.6758 109)"
            fill="#2D56B2"
          />
          <rect
            width="10.8561"
            height="1.87174"
            rx="0.935869"
            transform="matrix(0.707107 0.707107 0.707107 -0.707107 37 110.324)"
            fill="#2D56B2"
          />
        </g>
        <defs>
          <clipPath id="clip0_1648_21336">
            <rect width="128" height="128" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default TrackSvg;
